jQuery(document).ready(function($){

    $(document).on('click', '.img-vid-holder.video' , function(index, value){
        
        var video_source = $(this).data('video-type');

        if (video_source == 'embed'){

            var random_number = $(this).data('random-number');


            $(this).html('');
            var video_html = video_object[random_number];

            console.log(video_html);
            $(this).html(video_html);

        }

        else{
            $(this).find('.play-button').hide();
            $(this).find('img').hide();
            var video_element =  $(this).find('video');
            video_element.show();
            video_element[0].play();
        }

        
    });

    $('.icon-column-section h3').matchHeight();

    console.log(ThemeJS.Variables);


    $('.mobile-menu-button').click(function(){
        $(this).toggleClass('is-active');
        $('.mobile-menu-container').slideToggle();
    });

    $('.product-image-container').matchHeight();
    $('.product-content-container h3').matchHeight();


});

jQuery(document).on('gform_post_render', function(event, form_id, current_page){
 
    if ($('.gform_wrapper').length > 0){

        // $('.gform_footer input').addClass('btn-custom');
        // $('.gform_footer input').css('background-color', ThemeJS.Variables.brand_colour);


        $(document).on('focus', '.gform_wrapper input, .gform_wrapper textarea', function(){
            $(this).css('border', '1px solid '+ThemeJS.Variables.brand_colour);
        });

        $(document).on('blur', '.gform_wrapper input, .gform_wrapper textarea', function(){
            $(this).css('border', '1px solid #979797');
        })

        if (ThemeJS.Variables.text_colour == 'dark'){
            $('.gform_footer input').addClass('brand-color-dark');
        }
        
    }

});